import { goalImageMap } from '~/modules/retailMedia/components/CampaignForm/strategies/ObjectiveBased/helpers'
import { Flex } from '@vtex/shoreline'
import { t } from 'i18next'

interface GoalValueProps {
  goal: Goals
}

export const GoalValue = ({ goal }: GoalValueProps) => {
  if (!goal) return ''
  const goalImage = goalImageMap[goal]

  return (
    <Flex gap="var(--sl-space-2)">
      <span>{t(`rm:objectiveBased.card.${goal}.title`)}</span>
      {goalImage && (
        <img
          src={goalImage}
          alt={goal}
          style={{ width: '20px', height: '20px' }}
        />
      )}
    </Flex>
  )
}
